module.exports = __webpack_public_path__ + "media/images/sports_coaching/florian@2x-8e7f997ac781c085ba0607cd8cde6de4.jpg";